import InvestToPoolInterface from "./InvestToPoolInterface";

export default InvestToPoolInterface;
